import React, { useState } from 'react';
import { Dropdown, Tooltip, Menu } from 'antd';
import IconComponent from '../IconComponent/IconComponent';
import { modes, tooltipTitles, warrantyIds } from '../../../../config';
import { useChangeWarrantyModalDispatch } from '../../../../model';

const menuItems = [
  {
    key: modes.possWarrantyToRegular,
    content: 'Перевести в обычную',
  },
  {
    key: modes.possWarrantyToWarranty,
    content: 'Перевести в гарантийную',
  },
];

const Overlay = ({ onClick, ...props }) => {
  return (
    <Menu
      {...props}
      onClick={onClick}
    >
      {menuItems.map((item) => (
        <Menu.Item key={item.key}>{item.content}</Menu.Item>
      ))}
    </Menu>
  );
};

const PossWarrantyComponent = ({ request, actionProps }) => {
  const [visible, setVisible] = useState(false);
  const { open } = useChangeWarrantyModalDispatch();

  const handleMenuClick = (e) => {
    e.domEvent.stopPropagation();
    setVisible(false);
    open({ request, mode: e.key });
  };

  return (
    <Dropdown
      overlay={<Overlay onClick={handleMenuClick} />}
      trigger={['click']}
      onVisibleChange={setVisible}
      visible={visible}
    >
      <Tooltip title={tooltipTitles[warrantyIds.possWarranty].active}>
        <IconComponent
          {...actionProps}
          warrantyId={warrantyIds.possWarranty}
          onClick={(e) => e.stopPropagation()}
        />
      </Tooltip>
    </Dropdown>
  );
};

export default PossWarrantyComponent;
